import { useModalStore } from '@/shared/lib';
import { EditBankAddressModal } from '../ui';
import type { SavedBankAddress } from '@/entities/bank-address';

type Params = {
  savedBankAddress: SavedBankAddress;
  onBack: () => void;
};

export function useEditBankAddressModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openEditBankAddressModal = ({ savedBankAddress, onBack }: Params) => {
    showDialogComponent({
      component: (
        <EditBankAddressModal
          savedBankAddress={savedBankAddress}
          onBack={onBack}
        />
      ),
      className: 'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openEditBankAddressModal };
}
